import { render, staticRenderFns } from "./leftslip.vue?vue&type=template&id=3149241d&"
import script from "./leftslip.vue?vue&type=script&lang=js&"
export * from "./leftslip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports